import { render, staticRenderFns } from "./stretch-banner.vue?vue&type=template&id=61c1d89e&scoped=true"
import script from "./stretch-banner.vue?vue&type=script&lang=js"
export * from "./stretch-banner.vue?vue&type=script&lang=js"
import style0 from "./stretch-banner.vue?vue&type=style&index=0&id=61c1d89e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c1d89e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonButton: require('/builds/wj/fe/wenjuan-homesite/components/common/button.vue').default,CommonImage: require('/builds/wj/fe/wenjuan-homesite/components/common/image.vue').default,CommonStretchPage: require('/builds/wj/fe/wenjuan-homesite/components/common/stretch-page.vue').default})
